<template>
    <data-hud class="data-hud" title="HRV-RMSSD (Beta)" unit="ms" :data="data"/>
</template>

<script>
import DataHud from "./data-hud.vue"

export default 
  {
    name: 'hrv-rmssd',
    props: {
        data: String
    },
    setup() {
    },
    components: { DataHud }
}
</script>

<style scoped>
.data-hud {
    position: absolute;
    left: 135px;
    top: 930px;
}
</style>


